import dayjs from 'dayjs'
import { getCertificationSlotTime } from '@/helpers/certification/certificationTermsFormLogic'
import substituteCertificationDescriptionPlaceholders from '@/helpers/certification/substituteCertificationDescriptionPlaceholders'

function asIriList(arr) {
  if (!Array.isArray(arr)) return []
  return arr.map(f => (typeof f === 'string' ? f : f['@id']))
}

/**
 * Kalendarzowy YYYY-MM-DD z pickera (Date albo 'YYYY-MM-DD').
 */
function calendarYmd(dateValue) {
  if (dateValue == null || dateValue === '') return null
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue
  }
  return dayjs(dateValue).format('YYYY-MM-DD')
}

/**
 * Treść żądania POST/PUT dla API Platform (CreateInput / EditInput).
 * Daty i godziny slotów wysyłamy jako Y-m-d H:i (ściana czasu PL, bez strefy/UTC).
 */
export default function buildCertificationPayload(data, sendInformationEmail) {
  const ymd = calendarYmd(data.date)
  if (!ymd) {
    throw new Error('Brak daty certyfikacji')
  }

  const slotTimes = (data.slotTimeInputs || []).map(slot => {
    const raw = String(getCertificationSlotTime(slot) || '00:00')
    const parts = raw.split(':')
    const hh = (parts[0] || '00').padStart(2, '0')
    const mmRaw = (parts[1] || '00').split(/[.:]/)[0] || '00'
    const mm = String(parseInt(mmRaw, 10) || 0).padStart(2, '0')
    return `${ymd} ${hh}:${mm}`
  })

  const date = `${ymd} 00:00`

  return {
    kind: data.kind,
    description: substituteCertificationDescriptionPlaceholders(data.description, data),
    date,
    departments: data.departments,
    examiner: data.examiner,
    localization: data.localization,
    slotTimes,
    informationMaterials: asIriList(data.informationMaterials),
    reportMaterials: asIriList(data.reportMaterials),
    dealers: data.dealers || [],
    priceInGrosze: data.isFree ? 0 : data.priceInGrosze,
    isFree: !!data.isFree,
    status: data.status,
    sendInformationEmail: !!sendInformationEmail,
  }
}
